// Video data for JidduFilms - All videos hosted on Amazon S3
// Base URL: https://jiddufilms-bucket.s3.us-east-2.amazonaws.com/videos/
// Cover images URL: https://jiddufilms-bucket.s3.us-east-2.amazonaws.com/videos_cover/
// Optimizado para Cloudflare CDN cuando esté configurado

import { getOptimizedVideoUrl, getOptimizedImageUrl } from '../../ui/utils/cloudflareCDN';

const S3_BASE_URL = 'https://jiddufilms-bucket.s3.us-east-2.amazonaws.com';

// Generate video URL helper function - Usa Cloudflare si está configurado
const getVideoUrl = (filename) => getOptimizedVideoUrl(filename, 'videos');

// Generate cover image URL helper function - Usa Cloudflare si está configurado
const getCoverUrl = (filename) => getOptimizedImageUrl(filename, 'videos_cover');

// All 38 JidduFilms videos with their metadata
export const jidduFilmsVideos = [
  {
    id: 1,
    title: 'NETFLIX',
    filename: 'JidduFilms_Video_NETFLIX.mp4',
    url: getVideoUrl('JidduFilms_Video_NETFLIX.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_NETFLIX.png'),
    category: 'corporate',
    aspect: 'horizontal'
  },
  {
    id: 2,
    title: 'Let It Beat - The One',
    filename: 'JidduFilms_Video_LetItBeat-TheOne.mp4',
    url: getVideoUrl('JidduFilms_Video_LetItBeat-TheOne.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_LetItBeat-TheOne.png'),
    category: 'music',
    aspect: 'horizontal'
  },
  {
    id: 3,
    title: 'FuelFest',
    filename: 'JidduFilms_Video_FuelFest.mp4',
    url: getVideoUrl('JidduFilms_Video_FuelFest.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_FuelFest.png'),
    category: 'event',
    aspect: 'horizontal'
  },
  {
    id: 4,
    title: 'NYA',
    filename: 'JidduFilms_Video_NYA.mp4',
    url: getVideoUrl('JidduFilms_Video_NYA.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_NYA.png'),
    category: 'corporate',
    aspect: 'horizontal'
  },
  {
    id: 5,
    title: 'Frank',
    filename: 'JidduFilms_Video_Frank.mp4',
    url: getVideoUrl('JidduFilms_Video_Frank.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_Frank.png'),
    category: 'personal',
    aspect: 'horizontal'
  },
  {
    id: 6,
    title: 'MPC - TAPIA',
    filename: 'JidduFilms_Video_MPC-TAPIA.mp4',
    url: getVideoUrl('JidduFilms_Video_MPC-TAPIA.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_MPC-TAPIA.png'),
    category: 'mpc',
    aspect: 'horizontal'
  },
  {
    id: 7,
    title: 'MPC - RECAP DAY 3 MUJERES',
    filename: 'JidduFilms_Video_MPC-RECAP_DAY3_MUJERES.mp4',
    url: getVideoUrl('JidduFilms_Video_MPC-RECAP_DAY3_MUJERES.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_MPC-RECAP_DAY3_MUJERES.png'),
    category: 'mpc',
    aspect: 'horizontal'
  },
  {
    id: 8,
    title: 'MPC - AUPA MIAMI',
    filename: 'JidduFilms_Video_MPC-AUPAMIAMI.mp4',
    url: getVideoUrl('JidduFilms_Video_MPC-AUPAMIAMI.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_MPC-AUPAMIAMI.png'),
    category: 'mpc',
    aspect: 'horizontal'
  },
  {
    id: 9,
    title: 'MPD NYC',
    filename: 'JidduFilms_Video_MPD_NYC.mp4',
    url: getVideoUrl('JidduFilms_Video_MPD_NYC.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_MPD_NYC.png'),
    category: 'corporate',
    aspect: 'horizontal'
  },
  {
    id: 10,
    title: 'MPC - SEMIS',
    filename: 'JidduFilms_Video_MPC-SEMIS.mp4',
    url: getVideoUrl('JidduFilms_Video_MPC-SEMIS.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_MPC-SEMIS.png'),
    category: 'mpc',
    aspect: 'horizontal'
  },
  {
    id: 11,
    title: 'Golden Life',
    filename: 'JidduFilms_Video_Golden-Life.mp4',
    url: getVideoUrl('JidduFilms_Video_Golden-Life.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_Golden-Life.png'),
    category: 'event',
    aspect: 'horizontal'
  },
  {
    id: 12,
    title: 'Miami Royal',
    filename: 'JidduFilms_Video_MiamiRoyal.mp4',
    url: getVideoUrl('JidduFilms_Video_MiamiRoyal.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_MiamiRoyal.png'),
    category: 'event',
    aspect: 'horizontal'
  },
  {
    id: 13,
    title: 'MPC - SORTEO',
    filename: 'JidduFilms_Video_MPC-SORTEO.mp4',
    url: getVideoUrl('JidduFilms_Video_MPC-SORTEO.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_MPC-SORTEO.png'),
    category: 'mpc',
    aspect: 'vertical'
  },
  {
    id: 14,
    title: 'BTS - Fonzi',
    filename: 'JidduFilms_Video_BTS-Fonzi.mp4',
    url: getVideoUrl('JidduFilms_Video_BTS-Fonzi.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_BTS-Fonzi.png'),
    category: 'bts',
    aspect: 'vertical'
  },
  {
    id: 15,
    title: 'MediaPro VEN-ITA',
    filename: 'JidduFilms_Video_MediaPro-VEN-ITA.mp4',
    url: getVideoUrl('JidduFilms_Video_MediaPro-VEN-ITA.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_MediaPro-VEN-ITA.png'),
    category: 'mediapro',
    aspect: 'horizontal'
  },
  {
    id: 16,
    title: 'MPC - DAY 4 HIGHLIGHTS',
    filename: 'JidduFilms_Video_MPC-DAY4-HIGHLIGHTS.mp4',
    url: 'https://www.youtube.com/embed/c3T3hjyi8OE',
    poster: getCoverUrl('JidduFilms_img-portada_MPC-DAY4-HIGHLIGHTS.png'),
    category: 'mpc',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 17,
    title: 'VERIZON',
    filename: 'JidduFilms_Video_VERIZON.mp4',
    url: 'https://www.youtube.com/embed/z9eAt0tCOOc',
    poster: getCoverUrl('JidduFilms_img-portada_VERIZON.png'),
    category: 'corporate',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 18,
    title: 'MPC - RECAP FINAL',
    filename: 'JidduFilms_Video_MPC-RECAP_FINAL.mp4',
    url: 'https://www.youtube.com/embed/XIlGly6W5ro',
    poster: getCoverUrl('JidduFilms_img-portada_MPC-RECAP_FINAL.png'),
    category: 'mpc',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 19,
    title: 'German Garmendia',
    filename: 'JidduFilms_Video_GermanGarmendia.mp4',
    url: 'https://www.youtube.com/embed/j6AM2l7-RYU',
    poster: getCoverUrl('JidduFilms_img-portada_GermanGarmendia.png'),
    category: 'personal',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 20,
    title: 'SKYROS MPC',
    filename: 'JidduFilms_Video_SKYROS-MPC.mp4',
    url: 'https://www.youtube.com/embed/VWBVoTO8B04',
    poster: getCoverUrl('JidduFilms_img-portada_SKYROS-MPC.png'),
    category: 'mpc',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 21,
    title: 'MPC - DAY 1',
    filename: 'JidduFilms_Video_MPC-DAY1.mp4',
    url: 'https://www.youtube.com/embed/-SA3VR3zjoE',
    poster: getCoverUrl('JidduFilms_img-portada_MPC-DAY1.png'),
    category: 'mpc',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 22,
    title: 'Leading Edge',
    filename: 'JidduFilms_Video_LeadingEdge.mp4',
    url: 'https://www.youtube.com/embed/df8zLVvJFeU',
    poster: getCoverUrl('JidduFilms_img-portada_LeadingEdge.png'),
    category: 'corporate',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 23,
    title: 'MPC - RECAP DAY 3 HOMBRES',
    filename: 'JidduFilms_Video_MPC-RECAP_DAY3_HOMBRES.mp4',
    url: 'https://www.youtube.com/embed/9t43JLls3Es',
    poster: getCoverUrl('JidduFilms_img-portada_MPC-RECAP_DAY3_HOMBRES.png'),
    category: 'mpc',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 24,
    title: 'ROOFTOP',
    filename: 'JidduFilms_Video_ROOFTOP.mp4',
    url: getVideoUrl('JidduFilms_Video_ROOFTOP.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_ROOFTOP.png'),
    category: 'event',
    aspect: 'vertical'
  },
  {
    id: 25,
    title: 'MediaPro',
    filename: 'JidduFilms_Video_MediaPro.mp4',
    url: 'https://www.youtube.com/embed/P-rPC9b-uuI',
    poster: getCoverUrl('JidduFilms_img-portada_MediaPro.png'),
    category: 'mediapro',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 26,
    title: 'MPC - RECAP DAY 4',
    filename: 'JidduFilms_Video_MPC-RECAP_DAY4.mp4',
    url: 'https://www.youtube.com/embed/6rbPxKEjwSM',
    poster: getCoverUrl('JidduFilms_img-portada_MPC-RECAP_DAY4.png'),
    category: 'mpc',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 27,
    title: 'Jai Alai',
    filename: 'JidduFilms_Video_JaiAlai.mp4',
    url: getVideoUrl('JidduFilms_Video_JaiAlai.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_JaiAlai.png'),
    category: 'sport',
    aspect: 'vertical'
  },
  {
    id: 28,
    title: 'MPC - RECAP DAY 1',
    filename: 'JidduFilms_Video_MPC-RECAP_DAY1.mp4',
    url: 'https://www.youtube.com/embed/Iq88DTnfci8',
    poster: getCoverUrl('JidduFilms_img-portada_MPC-RECAP_DAY1.png'),
    category: 'mpc',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 29,
    title: 'MPC - PPL',
    filename: 'JidduFilms_Video_MPC-PPL.mp4',
    url: getVideoUrl('JidduFilms_Video_MPC-PPL.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_MPC-PPL.png'),
    category: 'ppl',
    aspect: 'vertical'
  },
  {
    id: 30,
    title: 'TRAPICHE',
    filename: 'JidduFilms_Video_TRAPICHE.mp4',
    url: getVideoUrl('JidduFilms_Video_TRAPICHE.mp4'),
    poster: getCoverUrl('JidduFilms_img-portada_TRAPICHE.png'),
    category: 'event',
    aspect: 'vertical'
  },
  {
    id: 31,
    title: 'Cantante 2',
    filename: 'JidduFilms_Video_Cantante-2.mp4',
    url: 'https://www.youtube.com/embed/UdQT77FEjr4',
    poster: getCoverUrl('JidduFilms_img-portada_Cantante-2.png'),
    category: 'music',
    aspect: 'vertical',
    isYouTube: true
  },
  {
    id: 32,
    title: 'VELADA GG',
    filename: 'JidduFilms_Video_VELADA-GG.mp4',
    url: 'https://www.youtube.com/embed/iN4N9FnibnY',
    poster: getCoverUrl('JidduFilms_img-portada_VELADA-GG.png'),
    category: 'event',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 33,
    title: 'MPC - MIAMI LAS VEGAS',
    filename: 'JidduFilms_Video_MPC-MIAMI-LASVEGAS.mp4',
    url: 'https://www.youtube.com/embed/JvrX4ckppuw',
    poster: getCoverUrl('JidduFilms_img-portada_MPC-MIAMI-LASVEGAS.png'),
    category: 'mpc',
    aspect: 'horizontal',
    isYouTube: true
  },
  {
    id: 34,
    title: 'PPL',
    filename: 'JidduFilms_Video_PPL.mp4',
    url: 'https://www.youtube.com/embed/sqX_QNHQ8oY',
    poster: getCoverUrl('JidduFilms_img-portada_PPL.png'),
    category: 'ppl',
    aspect: 'vertical',
    isYouTube: true
  },
  {
    id: 35,
    title: 'Cantante 1',
    filename: 'JidduFilms_Video_Cantante-1.mp4',
    url: 'https://www.youtube.com/embed/Hbz2eHADJ50',
    poster: getCoverUrl('JidduFilms_img-portada_Cantante-1.png'),
    category: 'music',
    aspect: 'vertical',
    isYouTube: true
  },
  {
    id: 36,
    title: 'BTS 1',
    filename: 'JidduFilms_Video_BTS-1.mp4',
    url: 'https://www.youtube.com/embed/lGkKi0SH7BM',
    poster: getCoverUrl('JidduFilms_img-portada_BTS-Fonzi.png'), // Using BTS-Fonzi cover as fallback
    category: 'bts',
    aspect: 'vertical',
    isYouTube: true
  },
  {
    id: 37,
    title: 'RUMOR PPL',
    filename: 'JidduFilms_Video_RUMOR-PPL.mp4',
    url: 'https://www.youtube.com/embed/2Cne5mBFqI8',
    poster: getCoverUrl('JidduFilms_img-portada_RUMOR-PPL.png'),
    category: 'ppl',
    aspect: 'vertical',
    isYouTube: true
  },
  {
    id: 38,
    title: 'BTS 2',
    filename: 'JidduFilms_Video_BTS-2.mp4',
    url: 'https://www.youtube.com/embed/MSLMaW_gSko',
    poster: getCoverUrl('JidduFilms_img-portada_BTS-Fonzi.png'), // Using BTS-Fonzi cover as fallback
    category: 'bts',
    aspect: 'vertical',
    isYouTube: true
  }
];

// Helper functions to filter videos by category and aspect ratio
export const getVideosByCategory = (category) => {
  return jidduFilmsVideos.filter(video => video.category === category);
};

export const getVideosByAspect = (aspect) => {
  return jidduFilmsVideos.filter(video => video.aspect === aspect);
};

export const getHorizontalVideos = () => {
  return getVideosByAspect('horizontal');
};

export const getVerticalVideos = () => {
  return getVideosByAspect('vertical');
};

// Get all unique categories
export const getVideoCategories = () => {
  return [...new Set(jidduFilmsVideos.map(video => video.category))];
};

// Convert to VideoGallerySection format
export const getVideoGalleryData = () => {
  const horizontalVideos = getHorizontalVideos().map(video => ({
    poster: video.poster,
    sources: video.isYouTube ? [] : [{ src: video.url, type: 'video/mp4' }],
    youtubeUrl: video.isYouTube ? video.url : null,
    isYouTube: video.isYouTube || false
  }));

  const verticalVideos = getVerticalVideos().map(video => ({
    poster: video.poster,
    sources: video.isYouTube ? [] : [{ src: video.url, type: 'video/mp4' }],
    youtubeUrl: video.isYouTube ? video.url : null,
    isYouTube: video.isYouTube || false
  }));

  return {
    horizontalItems: horizontalVideos,
    verticalItems: verticalVideos
  };
};

export default jidduFilmsVideos;
